<script setup lang='ts'>
import { LOAD_STATUS } from '@qcwp/common'
import type { CascaderSelectedSeries } from './hook'
import { useCascaderSeries } from './hook'
import type { VenderSeriesResponse, VendorResponse } from '~~/src/server/modules/car/types'

const props = withDefaults(defineProps<{
  brandId?: string
  seriesId?: string
}>(), {})
const emits = defineEmits({
  select: (data: CascaderSelectedSeries) => true,
})

function select(data: VenderSeriesResponse, item: VendorResponse) {
  emits('select', {
    ...data,
    carVendorName: item.carVendorName,
    carVendorId: item.carVendorId,
  })
}

const {
  seriesList,
  loadStatus,
  getSeriesList,
} = useCascaderSeries()

watchEffect(() => {
  if (props.brandId)
    getSeriesList(props.brandId)
})
</script>

<template>
  <div pr-3 items-start px-3>
    <n-scrollbar v-if="(loadStatus === LOAD_STATUS.END)">
      <ul>
        <li v-for="item in seriesList?.vender" :key="item.carVendorId">
          <div class="leading-10 font-bold">
            {{ item.carVendorName }}
          </div>
          <div v-if="(item.carSeriesList && item.carSeriesList.length)" class="flex flex-wrap gap-3">
            <div
              v-for="v in item.carSeriesList" :key="v.id"
              class="px-2 py-1 cursor-pointer rounded-sm "
              :class="[v.id === seriesId ? 'bg-primary text-white hover:text-white' : ' bg-gray-100  hover:text-primary']"
              @click="select(v, item)"
            >
              {{ v.carSeriesName }}
            </div>
          </div>
        </li>
      </ul>
    </n-scrollbar>
    <div v-if="(loadStatus === LOAD_STATUS.LOADING)" class="py-5 flex items-center  justify-center">
      <van-loading size="16" mr-2 />
      <span ml-2>加载中...</span>
    </div>
    <div v-if="(loadStatus === LOAD_STATUS.ERROR)" class="grid place-items-center py-5">
      <p text-4 text-gray-400>
        加载失败
      </p>
      <n-button
        mt-3
        strong secondary type="primary"
        @click="getSeriesList"
      >
        重新加载
      </n-button>
    </div>
  </div>
</template>
